/**
 * @file Onboarding access request form container.
 */

import compose from 'lodash.flowright';
import { graphql } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { mapProps } from '../../../util/hocs';
import OnboardingAccessRequestForm from '../../../components/onboarding/access-control/OnboardingAccessRequestForm';
import { AlbumFolderWithCreatorBrandDetails } from '../../../graphql/queries/album-folder';
import { albumFolderAccessRequest } from '../../../graphql/mutations/account';
import { MeQuery } from '../../../graphql/queries/account';

const withUserData = graphql(MeQuery, {
  props: ({ data: { me } }) => ({
    user: me,
  }),
  skip: ownProps => !ownProps.authenticated,
  options: {
    fetchPolicy: 'network-only',
  },
});

const withAlbumFolderData = graphql(AlbumFolderWithCreatorBrandDetails, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumFolderId,
    },
  }),
  props: ({ data: { albumFolder, loading } }) => ({
    albumFolder,
    loading,
  }),
});

const withAlbumFolderAccessRequestMutation = graphql(albumFolderAccessRequest, {
  props: ({ mutate }) => ({
    albumFolderAccessRequest: ({
      albumFolderId,
      firstName,
      lastName,
      phoneNumber,
      emailAddress,
      identityName,
      identityRelation,
      comments,
    }) =>
      mutate({
        variables: {
          input: {
            album_folder_id: albumFolderId,
            first_name: firstName,
            last_name: lastName,
            phone_number: phoneNumber,
            email_address: emailAddress,
            identity_name: identityName,
            relation_to_identity: identityRelation,
            comments: `${comments}\nAccess request: Sign-up\nParent Consent: Yes`,
          },
        },
      }),
  }),
});

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

export default compose(
  withRouter,
  connect(mapStateToProps),
  withUserData,
  withAlbumFolderData,
  withAlbumFolderAccessRequestMutation,
  mapProps(({ ...props }) => ({
    ...props,
    redirectUrl: `/discover/album-folder/${props.albumFolder?.id}`,
  })),
)(OnboardingAccessRequestForm);
